import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import FreeHomebuyingReadinessToolsPage from "@/pages/tools/FreeHomebuyingReadinessTools";

export const Route = createFileRoute("/tools/free-homebuying-readiness-tools")({
  head: () => seoHead("/tools/free-homebuying-readiness-tools"),
  component: FreeHomebuyingReadinessToolsPage,
});
